import getReverseComplementSequenceString from "./getReverseComplementSequenceString";
import getReverseComplementAnnotation from "./getReverseComplementAnnotation";
import { annotationTypes } from "./annotationTypes";
import { map } from "lodash-es";
import tidyUpSequenceData from "./tidyUpSequenceData";
import getSequenceDataBetweenRange from "./getSequenceDataBetweenRange";
export default function getReverseComplementSequenceAndAnnoations(pSeqObj, options = {}) {
  const seqObj = tidyUpSequenceData(
    getSequenceDataBetweenRange(pSeqObj, options.range),
    { doNotRemoveInvalidChars: true, ...options }
  );
  const newSeqObj = Object.assign(
    {},
    seqObj,
    {
      sequence: getReverseComplementSequenceString(seqObj.sequence)
    },
    annotationTypes.reduce((acc, type) => {
      if (seqObj[type]) {
        acc[type] = map(seqObj[type], (annotation) => {
          return getReverseComplementAnnotation(
            annotation,
            seqObj.sequence.length
          );
        });
      }
      return acc;
    }, {})
  );
  return tidyUpSequenceData(newSeqObj, {
    doNotRemoveInvalidChars: true,
    ...options
  });
}
